// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__p3llS","header":"ReportDetails_header__CrJ8_","title":"ReportDetails_title__1yDN1","left":"ReportDetails_left__2H7au"};